import React, { Component } from 'react';
import GuestClient from './guestclient';

var tr = require('ts-translate-js').default.boundTR;
var cIf = require('classnames');
var tsRest = require('ts-rest-client');

export class GuestClientInfoPanel extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            guestClient: (this.props.guestClient != null) ? this.props.guestClient : {},
            emailValidation: (this.props.guestClient != null && this.props.guestClient.email != null) ? this.props.guestClient.email : "",
        };

        this.isInEdition = this.props.isInEdition;
    }

    componentDidUpdate() {
        this.isInEdition = this.props.isInEdition;
    }

    //#region Prepare rendering
    displayShippingAddress() {
        return (
            <div>
                <br/>
                <address>
                    {this.state.guestClient.address}<br/>
                    {this.state.guestClient.address2}<br/>
                    {this.state.guestClient.city}<br/>
                    {this.state.guestClient.province + ", " + this.state.guestClient.country}<br/>
                    {this.state.guestClient.postalCode}<br/>
                </address>
            </div>
        );
    }

    createActionsButtons() {
        return (
            <div className="col-xs-12">
                <div className="btn-toolbar pull-right">
                    <button type="button" className="btn btn-default" onClick={() => this.handleOnGuestClientCancelled()}>{tr("profileedition.cancel")}</button>
                    <button type="button" className="btn btn-primary" onClick={() => this.handleOnCreate()}>{tr("profileedition.confirm")}</button>
                </div>
            </div>
        );
    }

    createEditInformationButton() {
        if (this.props.guestClient != null && !this.isInEdition) {
            return (
                <div className="col-md-6">
                    <button className="btn btn-default" type="button" onClick={() => this.handleEditGuestClient()}>
                        <span className="glyphicon glyphicon-pencil"></span> {tr("Éditer vos informations")}
                    </button>
                </div>
            );
        }
    }
    //#endregion

    //#region User interactions
    handleEditGuestClient() {
        this.props.handleGuestClientEdition();
        this.isInEdition = true;
        this.setState({
            showGuestClientCreationError: false,
            guestClientCreationError: null
        });
    }

    handleOnGuestClientCancelled() {
        this.isInEdition = false;
        this.props.onGuestClientCancelled();
    }
    
    handleOnGuestClientInfoChanged(guestClient) {
        this.setState({
            guestClient: guestClient,
            emailValidation: guestClient.emailValidation,
        });
    }
    //#endregion
    
    //#region API calls
    createGuestClientData() {
        return  {
            "firstName": this.state.guestClient.firstName,
            "lastName": this.state.guestClient.lastName,
            "email": this.state.guestClient.email,
            "homePhone": this.state.guestClient.homePhone,
            "postalCode": this.state.guestClient.postalCode,
            "address" : this.state.guestClient.address,
            "address2" :  this.state.guestClient.address2,
            "city" : this.state.guestClient.city,
            "province" : this.state.guestClient.province,
            "country" : this.state.guestClient.country,
            "hasAddress": this.props.hasMailDeliveries
        };
    }

    validateEmails() {
        return this.state.guestClient.email === this.state.emailValidation;
    }

    handleOnCreate() {
        tsRest.post("/sessions/current/guestclient", this.createGuestClientData())
              .done((success) => {
                  this.isInEdition = false;
                  this.props.onGuestClientCreated();
              }, (error) => {
                  var missingFields = [];
                  var isEmailInvalid = false;
                  var isEmailValidationInvalid = false;
                  var isPostalCodeInvalid = false;
                  var isPhoneNumberInvalid = false;

                  error.body.FieldValidationErrors.map((fieldError) => {
                      if (fieldError.ErrorName === "REQUIRED") {
                          missingFields.push(fieldError.FieldName);
                      } 

                      if (fieldError.ErrorName === "INVALID_FORMAT") {
                          if (fieldError.FieldName === "email") {
                              isEmailInvalid = true;
                          }
                          if (fieldError.FieldName === "emailValidation") {
                              isEmailValidationInvalid = true;
                          }
                          if (fieldError.FieldName === "postalCode") {
                              isPostalCodeInvalid = true;
                          }
                          if (fieldError.FieldName === "homePhone") {
                              isPhoneNumberInvalid = true;
                          }
                      }
                  });

                  this.setState({ 
                      showGuestClientCreationError: true,
                      guestClientCreationError: {
                          MissingFields: missingFields,
                          InvalidEmailFormat: isEmailInvalid,
                          InvalidEmailValidationFormat: isEmailValidationInvalid,
                          InvalidPostalCodeFormat: isPostalCodeInvalid,
                          InvalidEveningPhoneFormat: isPhoneNumberInvalid
                      }
                  });
              }
              );
    }
    //#endregion

    render() {
        var guestClientFullname = this.state.guestClient.firstName + " " + this.state.guestClient.lastName;
        var guestClientShippingAddress = (this.props.hasMailDeliveries && this.state.guestClient.address != null) ? this.displayShippingAddress() : this.state.guestClient.postalCode;
        var guestClientPanel = null;
        var actionsButtons = (this.isInEdition) ? this.createActionsButtons() : null;
        var editButton = this.createEditInformationButton();

        if (this.isInEdition) {
            // Pour le isNew on prend le guest en props car on doit savoir si c'est un guest à modifier ou un nouveau
            guestClientPanel = 
                <div className="col-md-12">
                    <GuestClient
                        showWholeForm={this.props.hasMailDeliveries}
                        guestClient={this.state.guestClient}
                        emailValidation={this.state.emailValidation}
                        onGuestClientInfoChanged={(guestClient) => this.handleOnGuestClientInfoChanged(guestClient)}
                        showGuestClientCreationError={this.state.showGuestClientCreationError}
                        guestClientCreationError={this.state.guestClientCreationError}
                        onContentChange={this.props.onContentChange}
                        isNew={this.props.guestClient === null}/>
                </div>;
        } else {
            guestClientPanel =
                <div className="col-md-6">
                    <address>
                        {guestClientFullname}<br/>
            {this.state.guestClient.email}<br/>
            {this.state.guestClient.homePhone}<br/>
            {guestClientShippingAddress}
                    </address>
                </div>;
        }
        return (
            <div className="row">
                <div className="col-md-12">
                    <h4>{tr("ordervalidation.yourinfo")}</h4>
                    <form className="well">
                        <div className="row">
                            {editButton}
                        </div>
                        <br/>
                        <div className="row">
                            {guestClientPanel}
                        </div>
                        <div className="row">
                            {actionsButtons}
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
